<template>
  <div class="invite-member">
    <back-navigation-header :on-back="onBack"/>
    <img class="top-image" :src="require('@/assets/invite-member.svg')"/>
    <div class="content">
      <div>
        <div class="title">הוספת שותפ.ה למנוי riseup</div>
        <div class="text">
          <div>אפשר לקבל את ההחלטות הכלכליות ביחד.</div>
          מי שיצטרף אליך
          <span class="bold"> יראה את כל המידע בתזרים, יוכל להוסיף חשבונות ויקבל את כל ההודעות בדיוק כמוך.</span>
          <div>&nbsp;</div>
          <span class="bold">הכנו לך</span>
          <span class="preview" v-on:click="showPreview"> הודעת הזמנה אישית</span>,
          כל מה שצריך הוא לשלוח אותה ב-WhatsApp.
        </div>
      </div>
      <riseup-button class="button"
        :icon="require('@/assets/whatsapp-icon.svg')"
        :title="'הזמנה דרך WhatsApp'"
        :action="inviteMember"/>
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex';
import BaseUI from 'base-ui';
import Segment from '../Segment';
import BackNavigationHeader from './app-header/BackNavigationHeader.vue';
import ModalBus from '../event-bus/modal-bus';
import InviteMemberHelpPopup from './onboarding/help-popups/InviteMemberHelpPopup.vue';
import config from '../config';
import router from '../router';

export default {
  name: 'InviteMember',
  components: {
    BackNavigationHeader,
    RiseupButton: BaseUI.RiseupButton,
  },
  computed: {
    ...mapState('session', ['inviteToken']),
    inviteMemberLink() {
      return `${config.get().elsaPublicUrl}/invite?accessToken=${this.inviteToken}`;
    },
    inviteMemberMessage() {
      // eslint-disable-next-line max-len
      return encodeURIComponent(`היי! *נרשמתי ל-riseup!*\nאני מחכה לך בתזרים המשותף שלנו 🎯\nכל מה שצריך לעשות בשביל להצטרף אליי זה *ללחוץ על הלינק המצורף* 👇\n${this.inviteMemberLink}`);
    },
  },
  methods: {
    onBack() {
      router.go(-1);
    },
    inviteMember() {
      Segment.trackUserInteraction('InviteMemberClicked');
      window.open(`https://api.whatsapp.com/send?text=${this.inviteMemberMessage}`, '_blank');
    },
    showPreview() {
      Segment.trackUserInteraction('InviteMemberPreviewClicked');
      ModalBus.$emit('open', {
        component: InviteMemberHelpPopup,
      });
    },
  },
};
</script>

<style lang="scss" scoped>
@import '../../node_modules/base-ui/src/scss/riseup-colors';
@import '../scss/mixins';

.invite-member {
  height: 100%;
  display: flex;
  flex-direction: column;

  .top-image {
    width: 100%;
  }

  .content {
    @include responsive-padding;
    @include responsive-padding-top-bottom;
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    flex-grow: 1;

    .title {
      font-size: 22px;
      line-height: 28px;
      font-weight: bold;
      margin-bottom: 15px;
    }

    .text {
      font-size: 16px;
      line-height: 24px;
      .bold {
        font-weight: bold;
      }
      .preview {
        color: $riseup_light_blue;
        font-weight: bold;
        cursor: pointer;
        text-decoration: underline;
      }
    }

    .riseup-button {
      align-self: flex-end;
      margin-top: 30px;
      width: 100%;
      height: 72px;
    }
  }
}
</style>
